import './pageHeader.css'

export default function PageHeader({children}){
    return (<div className = "view-header">
        <p>{children}</p>
    </div>)
}